import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { StatCard, PageHeader, Badge } from "@/components/Kit";
import { Users, IndianRupee, CalendarCheck, AlertTriangle, BookOpen } from "lucide-react";

const inr = (n) => "₹" + (n || 0).toLocaleString("en-IN");

export default function SchoolDashboard() {
  const { school } = useAuth();
  const { data, isLoading } = useQuery({
    queryKey: ["school-dashboard"],
    queryFn: async () => (await api.get("/school/dashboard")).data,
  });

  if (isLoading || !data) return <div className="text-slate-400">Loading…</div>;

  return (
    <div data-testid="school-dashboard">
      <PageHeader title={`${school?.name || "School"} Dashboard`} subtitle="Live snapshot of your institution today" />

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard testid="s-students" icon={Users} label="Students" value={data.students} accent="#4F46E5" delay={0} />
        <StatCard testid="s-fees" icon={IndianRupee} label="Fees Collected" value={inr(data.fees_collected)} accent="#10B981" delay={0.05} />
        <StatCard testid="s-attendance" icon={CalendarCheck} label="Attendance Today" value={`${data.attendance_pct}%`} accent="#06B6D4" delay={0.1} />
        <StatCard testid="s-dues" icon={AlertTriangle} label="Pending Dues" value={inr(data.pending_dues)} accent="#F43F5E" delay={0.15} />
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5 lg:grid-cols-3">
        <div className="ep-card p-5 lg:col-span-2">
          <p className="mb-4 text-sm font-semibold text-white">Recent Fee Receipts</p>
          {data.recent_receipts?.length ? (
            <div className="space-y-2">
              {data.recent_receipts.map((r) => (
                <div key={r.id} className="flex items-center justify-between rounded-xl border border-slate-800 px-4 py-3">
                  <div>
                    <p className="text-sm font-medium text-white">{r.student_name}</p>
                    <p className="font-mono text-xs text-slate-500">{r.receipt_no}</p>
                  </div>
                  <span className="text-sm font-semibold text-emerald-400">{inr(r.total)}</span>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm text-slate-500">No receipts yet. Collect fees from the Fees tab.</p>
          )}
        </div>
        <div className="ep-card flex flex-col items-center justify-center p-5 text-center">
          <BookOpen size={30} className="text-indigo-400" />
          <p className="mt-3 text-3xl font-bold font-head text-white">{data.homework_count}</p>
          <p className="text-xs uppercase tracking-wider text-slate-400">Homework Assigned</p>
        </div>
      </div>
    </div>
  );
}
